import CONFIG from '../../../../app.config';

export const ONTARIO_INSURANCES = {
  blueCross: 'Blue Cross',
  desjardins: 'Desjardins Group',
  canadaLife: 'Canada Life',
  greenShield: 'Green Shield Canada',
  manulife: 'Manulife Financial',
  sunlife: 'Sun Life Financial',
};

export const VALID_REGIONS_URL = `${
  CONFIG.SEARCH_APP_URL
}/support/where-can-i-claim`;

export const OFFER_TERMS_URL = `${CONFIG.SEARCH_APP_URL}/terms/offers`;
